import isEmpty from "lodash/isEmpty";
import formatMoney from "./formatMoney";

const emptyGroupChecker = (sortedFundraisersByGroup, groups) => {
  const sortedFundraisersByGroupIds = Object.values(sortedFundraisersByGroup).map(
    (group) => group.id
  );

  groups.forEach((group) => {
    const groupName = group.name;
    if (!sortedFundraisersByGroupIds.includes(group.id)) {
      sortedFundraisersByGroup[groupName] = group;
    }
  });
  return sortedFundraisersByGroup;
};

export default function fundraiserGroupParser(fundraisers: $FixMe, groups = []) {
  const newFundraisers = [...fundraisers].sort(
    (a, b) => b.amountRaised.dollarsAmount - a.amountRaised.dollarsAmount
  );

  const noGroupObject = {
    id: "__noGroup__",
    name: "No Subgroup",
    fundraisers: [],
    amountRaised: {
      dollarsAmount: null,
      formatted: "",
    },
  };

  const pendingMembersObject = {
    id: "__pending__",
    name: "Pending Members",
    fundraisers: [],
    amountRaised: {
      dollarsAmount: null,
      formatted: "",
    },
  };

  const sortedFundraisersByGroup = {
    noGroup: { fundraisers: [] },
    pendingMembers: { fundraisers: [] },
  };

  newFundraisers.forEach((fundraiser: $FixMe) => {
    if (fundraiser.group && !!fundraiser.group.id) {
      const groupName = fundraiser.group.name;
      if (!Object.keys(sortedFundraisersByGroup).includes(groupName)) {
        sortedFundraisersByGroup[groupName] = fundraiser.group;
        sortedFundraisersByGroup[groupName].fundraisers = [fundraiser];
      } else {
        sortedFundraisersByGroup[groupName].fundraisers.push(fundraiser);
      }
    } else if (
      !sortedFundraisersByGroup.pendingMembers.fundraisers.includes(fundraiser) &&
      !fundraiser.joinedAt &&
      !fundraiser.deactivatedAt &&
      !fundraiser.group &&
      !fundraiser.isDirect
    ) {
      pendingMembersObject.fundraisers.push(fundraiser);
    } else if (!sortedFundraisersByGroup.noGroup.fundraisers.includes(fundraiser)) {
      noGroupObject.fundraisers.push(fundraiser);
    }
  });

  const fundraiserAmountRaisedSumMaker = ({ fundraisers }) => {
    const fundraisersAmountRaisedArray = fundraisers.map(
      (fundraiser) => fundraiser.amountRaised.dollarsAmount
    );
    return isEmpty(fundraisersAmountRaisedArray)
      ? 0
      : fundraisersAmountRaisedArray.reduce((a, c) => a + c);
  };

  const noGroupFundraisersAmountRaised = fundraiserAmountRaisedSumMaker(noGroupObject);

  noGroupObject.amountRaised.dollarsAmount = noGroupFundraisersAmountRaised;
  noGroupObject.amountRaised.formatted = formatMoney(noGroupFundraisersAmountRaised);
  sortedFundraisersByGroup.noGroup = noGroupObject;

  const pendingMembersAmountRaised = fundraiserAmountRaisedSumMaker(pendingMembersObject);

  pendingMembersObject.amountRaised.dollarsAmount = pendingMembersAmountRaised;
  pendingMembersObject.amountRaised.formatted = formatMoney(pendingMembersAmountRaised);
  sortedFundraisersByGroup.pendingMembers = pendingMembersObject;

  return emptyGroupChecker(sortedFundraisersByGroup, groups);
}
